/* eslint-disable @typescript-eslint/no-explicit-any */

import Image from 'next/image'

import { useRef, useState } from 'react'

import Article from '@/components/Article'
import Modal from '@/components/Modal'

import { getImageUrl } from '@/api/sanity'

import BEMHelper from '@/helpers/bem'
import { SanityImageObject } from '@sanity/image-url/lib/types/types'
import styles from './Styles.module.scss'
import { byline } from '@/helpers/utils'
const bem = BEMHelper(styles)

interface Props {
  slug: string
  title: string
  preamble: string
  publishedAt?: string
  date?: string
  source?: string
  _id: string
  _type: string
  image: (SanityImageObject & { alt?: string }) | string
  loanArticle: string
  loanArticleSource: string
  data: any
}

export default function ArticleEntry({
  title,
  image,
  source,
  publishedAt,
  date,
  loanArticle,
  data,
  loanArticleSource,
}: Props) {
  const fromElement = useRef<HTMLButtonElement>(null)
  const [expanded, setExpanded] = useState(false)
  const [loadArticle, setLoadArticle] = useState(false)

  const src =
    typeof image === 'object' && 'asset' in image
      ? getImageUrl(image).width(600).height(400).url()
      : image
  const published = data?._updatedAt || publishedAt || date

  const toggle = (value: boolean) => () => {
    setExpanded(value)

    if (value && !loadArticle) {
      setLoadArticle(true)
    }
  }

  return (
    <>
      <button
        type="button"
        {...bem('', { 'no-image': !src })}
        ref={fromElement}
        onClick={toggle(true)}
      >
        {src && (
          <Image
            {...bem('image')}
            src={src}
            alt={typeof image === 'object' && 'alt' in image && image.alt ? image.alt : ''}
            width={300}
            height={200}
          />
        )}
        <div {...bem('content')}>
          <h3 {...bem('title')}>{title}</h3>
          {(published || source) && (
            <span {...bem('meta')}>
              {byline({ ...data, publishedAt, loanArticle, loanArticleSource })}
            </span>
          )}
        </div>
      </button>

      <Modal
        expanded={!!expanded}
        fromElement={fromElement?.current}
        onClose={toggle(false)}
        preventClickOutside
        article
        autoWidth={undefined}
      >
        {data ? <Article {...data} fluid /> : null}
      </Modal>
    </>
  )
}
